import {
  WSTable,
  WSTableColumnSortDirection
} from "@wingspanhq/fe-component-library";
import { IPayableSchema, IWorkLog } from "@wingspanhq/payments/dist/interfaces";
import { useMemo } from "react";
import { IPayeeRow } from "../../../../services/search";
import { getColumns } from "./columns";

export type TableItemData = IWorkLog;

type Props = {
  workLogs: IWorkLog[];
  payeesMap: Map<string, IPayeeRow>;
  payablesMap?: Map<string, IPayableSchema>;
  onRowClick?: (workLog: IWorkLog) => void;
  onSortByUpdatedAt: (newDirection: WSTableColumnSortDirection) => void;
  updatedAtDirection?: WSTableColumnSortDirection;
};

export const TableWorkLogsPayerView: React.FC<Props> = props => {
  const tableData = useMemo(() => {
    return props.workLogs.map(workLog => ({
      id: workLog.workLogId,
      data: workLog
    }));
  }, [props.workLogs]);

  const columns = useMemo(
    () =>
      getColumns({
        payeesMap: props.payeesMap,
        payablesMap: props.payablesMap,
        onSortByUpdatedAt: props.onSortByUpdatedAt,
        updatedAtDirection: props.updatedAtDirection
      }),
    [
      props.payeesMap,
      props.payablesMap,
      props.onSortByUpdatedAt,
      props.updatedAtDirection
    ]
  );

  const handleRowClick = props.onRowClick
    ? (item: { id: string; data: IWorkLog }) => props.onRowClick!(item.data)
    : undefined;

  return (
    <WSTable<TableItemData>
      tableData={tableData}
      columns={columns}
      onRowClick={handleRowClick}
    />
  );
};
